import React, { useEffect } from "react";
import * as actions from "../../../store/actions/index";
import { connect } from "react-redux";
import { string_to_slug } from "../../../store/utility";
import SearchProductsAdmin from "../SearchProductsAdmin/SearchProductsAdmin";
import { withRouter } from "react-router-dom";

const SearchAdminComponent = (props) => {
  let { searchKey, suggestion } = props.match.params;

  if (!searchKey || !suggestion) {
    searchKey = props.searchKey;
    suggestion = props.suggestion;
  }

  useEffect(() => {
    try {
      if (string_to_slug(searchKey) !== suggestion) {
        let sug = null;

        if (suggestion != "results") {
          //Incase entered rather than selecting any option then suggesstion becomes "results"

          sug = suggestion.replaceAll("-", " ");
        }

        props.getSearchProducts(searchKey, sug);
      }
    } catch (err) {}
  }, [searchKey, suggestion]);

  if (!searchKey || !suggestion) {
    return null;
  }
  return (
    <>
      <SearchProductsAdmin
        key={Math.random() * 10000}
        editProductBtn={true}
        deleteProductBtn={true}
      />
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSearchProducts: (searchKey, suggestion) =>
      dispatch(actions.fecthSearchProducts(searchKey, suggestion)),
  };
};
export default connect(
  null,
  mapDispatchToProps
)(withRouter(SearchAdminComponent));
